import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import imgHome from '../../assets/images/home-colon.jpg'
import questionarioOnline from '../../assets/images/questionario-online.jpg'
import ricercaMedica from '../../assets/images/ricerca-medica.png'
import anonimo from '../../assets/images/anonimo.png'
import manoCuore from '../../assets/images/mano-cuore.png'
import { PAGINE } from '..'
import { Container, Image } from 'gf-ui'
import HeaderColon from './components/HeaderColon'
import "./HomeColon.scss"
import Footer from '../../components/Footer'
import PageContainer from '../../components/PageContainer'

const HomeColon = ({ tipologia }) => {
    return <PageContainer tipologia={tipologia}>
        <Container className='bg-white p-0 rounded overflow-hidden shadow'>
            <HeaderColon subtitle="Questionario per la prevenzione del tumore del colon-retto" />

            <section className='section-main-home my-4'>
                <Row>
                    <Col xs={12} md={12} xl={7} xxl={6}>
                        <div className='p-4 m-4 home-title-colon'>
                            Effettuare controlli regolari al colon-retto è fondamentale per la prevenzione e la <span className='text-primary fw-bold'>diagnosi precoce</span> di malattie gravi, come il tumore al colon-retto,
                            uno dei più comuni a livello mondiale. La diagnosi precoce aumenta notevolmente le possibilità di successo nel trattamento,
                            riducendo il rischio di complicazioni e di interventi più invasivi. I controlli permettono inoltre di identificare polipi o altre anomalie che, se trattati in tempo,
                            possono prevenire lo sviluppo del cancro. A partire dai 50 anni, o prima in caso di familiarità o fattori di rischio, è consigliato sottoporsi a screening periodici,
                            come la colonscopia. La prevenzione è la chiave per mantenere una buona salute e ridurre la mortalità legata a questa patologia.
                        </div>
                    </Col>
                    <Col xs={12} md={12} xl={5} xxl={6} className='d-none d-md-flex' style={{ backgroundImage: 'URL(' + imgHome + ')', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center right' }} />
                </Row>
            </section>

            <section className='m-4 p-4'>
                <h1 className='text-center text-uppercase text-primary fw-bold my-4 py-4'>Perché partecipare?</h1>
                <div className='d-flex flex-row align-items-start justify-content-between'>
                    <div className='punto-perche-partecipare'>
                        <Image src={ricercaMedica} style={{ height: '80px' }} />
                        <strong>Contribuisci alla ricerca</strong>
                        <span className='text-center'>Le tue risposte ci aiuteranno a raccogliere dati preziosi per la prevenzione.</span>
                    </div>

                    <div className='punto-perche-partecipare'>
                        <Image src={anonimo} style={{ height: '80px' }} />
                        <strong>Anonimato garantito</strong>
                        <span className='text-center'>Il questionario è completamente anonimo e le tue risposte saranno trattate con la massima riservatezza</span>
                    </div>

                    <div className='punto-perche-partecipare'>
                        <Image src={manoCuore} style={{ height: '80px' }} />
                        <strong>Fai la differenza</strong>
                        <span className='text-center'>Ogni risposta conta e può aiutare a salvare vite</span>
                    </div>
                </div>
            </section>

            <section className='section-secondary-home'>
                <Row>
                    <Col xs={12} md={12} xl={5} xxl={4} className='d-none d-md-flex' style={{ backgroundImage: 'URL(' + questionarioOnline + ')', backgroundSize: 'cover', backgroundPosition: 'center center' }} />
                    <Col xs={12} md={12} xl={7} xxl={8}>
                        <div className='m-4 p-4 home-title-bottom'>
                            <strong className='fw-bold'>La tua salute è la nostra priorità, e la tua privacy lo è altrettanto.</strong>
                            <div>
                                Il questionario che ti chiediamo di compilare è completamente anonimo: nessuna informazione personale verrà registrata o collegata a te.
                                Rispondendo in modo sincero, ci aiuterai a comprendere meglio le tue necessità e a promuovere una prevenzione efficace del tumore del colon-retto.
                                Il tuo contributo, anche se anonimo, può fare la differenza per la tua salute e quella di tanti altri. Insieme, possiamo prevenire e proteggere.
                            </div>
                        </div>
                    </Col>
                </Row>
            </section>

            <section className='my-4 py-4'>
                <Row>
                    <Col >
                        <nav className="text-center">
                            <Link to={`/${tipologia.URL}${PAGINE.QUESTIONARIO.URL(tipologia)}`} className="btn-inizia"><span>Inizia il</span><span className='questionario-link'> questionario</span></Link>
                        </nav>
                    </Col>
                </Row>
            </section>

            <Footer tipologia={tipologia} />
        </Container>
    </PageContainer>
}

export default HomeColon